import { Trans } from '@lingui/macro'

import * as React from 'react'

import { Text } from '~ui/components/typography/Text/Text'

type TProps = NoChildren

/**
 * Simple translated text informing that the product is sold out.
 */
export const ProductIsSoldOutNote: React.FC<TProps> = () => {
  return (
    <Text>
      <Trans>Product is sold out</Trans>
    </Text>
  )
}
